import { HUtils as MHUtils, HRegex } from "@macashipo/mlib"
import Tooltip from "src/core/components/Others/Tooltip"
import Popover from "src/core/components/Others/Popover"
const HUtils = {
  Obj: {
    get: (obj, key) => {
      return MHUtils.get(obj, key)
    },
  },
  SquareBracket: {
    replace: (string, data, opts) => {
      // HRegex.re
    },
  },
  runFnList: (fnList, name, args) => {
    return MHUtils.runFuntion(fnList, name, args)
  },
}
const HConstant = {
  UIFnCore: {
    //fnFrom MyUI Core
    myData: "myData", //get data from this.props.data
    myChange: "myChange", //call function from onChange
    myBlur: "myBlur", //call function from onBlur
  },
}
export { HUtils, HConstant, Tooltip, Popover }
